import { t } from "@utils/i18n";
import { yup } from "@utils/validation/validation";

export const CustomCourseFieldSchema = yup.object().shape({
  type: yup.string(),
  dropdown_items: yup
    .array()
    .nullable()
    .when("type", {
      is: "dropdown",
      then: yup
        .array()
        .of(
          yup.object().shape({
            item: yup
              .string()
              .max(150)
              .test(
                "not-only-semicolons",
                () => t("errors.coursesSettings.customCourseFields.invalidDropdownValue"),
                (value) => !/^[;]+$/.test(value?.trim() || ""),
              ),
            default: yup.boolean(),
          }),
        )
        .min(1)
        .max(5000),
    }),
  name: yup.string().required().trim().max(80),
});
